import { render, staticRenderFns } from "./FormSepa.vue?vue&type=template&id=36c1728b&scoped=true&"
import script from "./FormSepa.vue?vue&type=script&lang=js&"
export * from "./FormSepa.vue?vue&type=script&lang=js&"
import style0 from "./FormSepa.vue?vue&type=style&index=0&id=36c1728b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1728b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VContainer,VForm,VRow,VTextField})
